<template>
    <transition
        :appear="appear"
        name="def-slide-right"
        class="def-slide-right"
    >
        <slot />
    </transition>
</template>

<script>
export default {
    name: 'DefSlideRight',
    props: ['appear']
}
</script>

<style lang="scss" scoped>
.def-slide-right-enter-active,
.def-slide-right-leave-active {
    transition: all .5s;
}
.def-slide-right-enter-from,
.def-slide-right-leave-to {
    transform: translateX(100%);
}
</style>